<template>
  <div>
    <div class="inner-header ">
      <nav class="navbar fixed-top bg-white animate__animated animate__slideInRight">
        <a  @click="$router.go(-1)" class="back-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
               <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                  <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2"/>
                  <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2"/>
               </g>
            </svg>
         </a>
         <a href="javascript:void(0);" class="link-title">New Enquiry</a>
      </nav>
    </div>
    <div class="inner-page bg-white animate__animated animate__slideInRight">
        <div class="container-fluid">
            <div class="row">
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card details-card form-card">
                        <div class="card-body p-0">
                            <div class="row">
                                <div class="col-12">
                                    <span class="lead-heading mt-4 mb-4">Enquiry Basic Detail</span>
                                </div>
                                <div class="col-12">
                                    <b-form @submit.prevent="AddEnquiry">
                                        <b-form-group>
                                          <label>Name<span class="text-danger">*</span></label>
                                            <b-form-input  type="text" v-model="AddNewEnquiry.name" placeholder="Full Name" required></b-form-input>
                                        </b-form-group>
                                          <b-form-group>
                                            <label>Mobile<span class="text-danger">*</span></label>
                                            <b-form-input  type="text"  v-model="AddNewEnquiry.phone" required minlength="10" placeholder="Mobile Number" ></b-form-input>
                                        </b-form-group>
                                          <b-form-group>
                                            <label>Email<span class="text-danger">*</span></label>
                                            <b-form-input  type="email"  v-model="AddNewEnquiry.email" placeholder="Email Address" required ></b-form-input>
                                        </b-form-group>
                                        <b-form-group>
                                            <label>Select Status<span class="text-danger">*</span></label>
                                            <b-form-select v-model="AddNewEnquiry.status_id" :options="EnquirystatusesList" required ></b-form-select>
                                        </b-form-group>
                                        <b-form-group class="form-group  mb-4p-0 ">
                                          <label for="firmName">Select Broker<span class="text-danger">*</span></label>
                                          <multiselect v-model="brokerSelected" :searchable="true" placeholder="Select Broker" label="name" class="form-multiselect" ref="brokerselect" track-by="id" :options="firmList" :multiple="false" :taggable="false" @input="selectBroker"></multiselect>
                                        </b-form-group>
                                           <b-form-group>
                                             <label>NCD<span class="text-danger">*</span></label>
                                            <datetime type="datetime" v-model="AddNewEnquiry.next_call_date" required placeholder="Next Call Date And Time"></datetime>
                                        </b-form-group>
                                          <b-form-group>
                                            <label>Project Name<span class="text-danger">*</span></label>
                                              <b-form-select v-model="AddNewEnquiry.building_id" :options="projects" required ></b-form-select>
                                        </b-form-group>
                                        <b-form-group v-if="AddNewEnquiry.building_id === 26">
                                          <label>Enquiry<span class="text-danger">*</span></label>
                                            <b-form-input  type="text" v-model="AddNewEnquiry.enquiry" placeholder="Enquiry" required></b-form-input>
                                        </b-form-group>
                                          <b-form-group>
                                            <label>Lead Source<span class="text-danger">*</span></label>
                                              <b-form-select   v-model="AddNewEnquiry.enquiry_source_id" required :options="LeadSourcesList" ></b-form-select>
                                        </b-form-group>
                                          <b-form-group>
                                            <label>IsNri<span class="text-danger">*</span></label>
                                              <b-form-select   v-model="AddNewEnquiry.is_nri" required :options="NriList" ></b-form-select>
                                        </b-form-group>
                                          <b-form-group>
                                          <label>Comment<span class="text-danger">*</span></label>
                                         <b-form-textarea v-model="AddNewEnquiry.comment" required placeholder="Add Comment" rows="3" max-rows="6" ></b-form-textarea>
                                          </b-form-group>
                                            <b-form-group class="mt-5">
                                        <b-button variant="primary" type="submit" block>Save</b-button>
                                          </b-form-group>
                                    </b-form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect'

export default {
  components: {
    datetime: Datetime,
    Multiselect
  },
  name: 'Enquiry',
  data () {
    return {
      projects: [{value: null, text: 'Select One'}],
      NriList: [{value: null, text: 'Select One'}, {value: true, text: 'Yes'}, {value: false, text: 'No'}],
      AddNewEnquiry: {
        name: null,
        phone: null,
        email: null,
        status_id: null,
        broker_id: null,
        next_call_date: null,
        building_id: null,
        enquiry: null,
        enquiry_source_id: null,
        is_nri: false,
        comment: null
      },
      brokerSelected: {
        id:null,
        name:'Select Broker'
      }
    }
  },
  mounted(){
    this.selectBroker();
  },
  methods: {
    FetchProjectDetails() {
      this.projects = []
      this.$axios.get(`/enquiries_builders/broker_buildings?id=${this.brokerSelected.id}`).then((res) => {
        res.data.buildings.forEach((item,index) => {
          this.projects.push({value: item.id, text: item.name})
        });
      });
    },
    AddEnquiry() {
      this.AddNewEnquiry.broker_id = this.brokerSelected.id
      this.$axios
        .post("enquiries_builders/create_enquiry", { enquiry : this.AddNewEnquiry })
        .then((res) => {
          swal({
            title: "Enquiry Created!",
            icon: "success",
          }).then(this.$router.replace({ name: "Home" }));
        })
        .catch((err) => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        });
    },
    selectBroker() {
      if(this.brokerSelected && this.brokerSelected.id){
        this.FetchProjectDetails();
      }
      this.$nextTick(()=> {
        if(this.$refs.brokerselect){
          this.$refs.brokerselect.$el.querySelector('input').required = !this.brokerSelected || !this.brokerSelected.id;    
        }
      });
    }
  },
  computed: {
    EnquirystatusesList() {
      return this.$store.getters.EnquirystatusesMaster;
    },
    LeadSourcesList() {
      return this.$store.getters.EnquirySources;
    },
    firmList() {
      let brokers = []
      this.$store.getters.brokersMaster.forEach(broker => {
        brokers.push({id: broker.value, name: broker.text})
      })
      return brokers;
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
